var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpense2EmptyState(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 344,
    viewBox: "0 0 422 344",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.568 301.567C293.45 301.567 360.643 234.373 360.643 151.196C360.643 68.018 293.45 0.824707 210.568 0.824707C127.687 0.824707 60.4934 68.018 60.4934 151.196C60.4934 234.373 127.687 301.567 210.568 301.567Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M377.811 89.3303C384.513 89.3303 389.947 83.8968 389.947 77.1941C389.947 70.4914 384.513 65.0579 377.811 65.0579C371.108 65.0579 365.674 70.4914 365.674 77.1941C365.674 83.8968 371.108 89.3303 377.811 89.3303Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.572 41.6734C400.149 41.6734 403.86 37.9626 403.86 33.3852C403.86 28.8078 400.149 25.097 395.572 25.097C390.994 25.097 387.283 28.8078 387.283 33.3852C387.283 37.9626 390.994 41.6734 395.572 41.6734Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4285 97.9145C55.006 97.9145 58.7167 94.2037 58.7167 89.6263C58.7167 85.0489 55.006 81.3381 50.4285 81.3381C45.8511 81.3381 42.1404 85.0489 42.1404 89.6263C42.1404 94.2037 45.8511 97.9145 50.4285 97.9145Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8203 278.182C74.3212 278.182 81.2126 271.291 81.2126 262.79C81.2126 254.289 74.3212 247.398 65.8203 247.398C57.3193 247.398 50.428 254.289 50.428 262.79C50.428 271.291 57.3193 278.182 65.8203 278.182Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_34_8869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.907 246.123H91.8208C77.3351 246.123 65.8208 234.609 65.8208 220.123V83.0659C65.8208 68.5802 77.3351 57.0659 91.8208 57.0659H329.907C344.392 57.0659 355.907 68.5802 355.907 83.0659V220.123C355.907 234.609 344.392 246.123 329.907 246.123Z",
    fill: "url(#paint0_linear_34_8869)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.364 203.409H101.478C98.1354 203.409 95.5354 200.809 95.5354 197.466C95.5354 194.123 98.1354 191.523 101.478 191.523H139.364C142.707 191.523 145.307 194.123 145.307 197.466C145.307 200.809 142.707 203.409 139.364 203.409Z",
    fill: "#D5DDEA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.649 203.409H162.764C159.421 203.409 156.821 200.809 156.821 197.466C156.821 194.123 159.421 191.523 162.764 191.523H200.649C203.992 191.523 206.592 194.123 206.592 197.466C206.592 200.809 203.992 203.409 200.649 203.409Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M261.935 203.409H224.049C220.706 203.409 218.106 200.809 218.106 197.466C218.106 194.123 220.706 191.523 224.049 191.523H261.935C265.277 191.523 267.877 194.123 267.877 197.466C267.877 200.809 265.277 203.409 261.935 203.409Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M323.22 203.409H285.334C281.991 203.409 279.391 200.809 279.391 197.466C279.391 194.123 281.991 191.523 285.334 191.523H323.22C326.563 191.523 329.163 194.123 329.163 197.466C329.163 200.809 326.563 203.409 323.22 203.409Z",
    fill: "#D5DDEA"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M309.478 132.094C321.786 132.094 331.763 122.116 331.763 109.808C331.763 97.5004 321.786 87.5227 309.478 87.5227C297.17 87.5227 287.192 97.5004 287.192 109.808C287.192 122.116 297.17 132.094 309.478 132.094Z",
    fill: "#15112D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M280.134 132.094C292.442 132.094 302.42 122.116 302.42 109.808C302.42 97.5004 292.442 87.5227 280.134 87.5227C267.826 87.5227 257.849 97.5004 257.849 109.808C257.849 122.116 267.826 132.094 280.134 132.094Z",
    fill: "#696677"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M142.707 139.152H101.107C98.1354 139.152 95.5354 136.552 95.5354 133.58V106.837C95.5354 103.866 98.1354 101.266 101.107 101.266H142.335C145.307 101.266 147.907 103.866 147.907 106.837V133.58C148.278 136.552 145.678 139.152 142.707 139.152Z",
    fill: "#D5DDEA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M378.739 248.412C377.555 253.444 375.779 258.772 373.707 263.212C368.082 274.164 359.202 282.748 348.25 288.373C337.002 293.997 323.682 296.365 310.361 293.405C278.985 286.893 258.856 256.108 265.368 224.731C271.881 193.355 302.369 172.93 333.746 179.738C344.994 182.107 354.762 187.731 363.05 195.427C376.963 209.339 382.883 229.467 378.739 248.412Z",
    fill: "#7647EE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M340.554 231.54H327.234V218.219C327.234 215.555 325.162 213.187 322.202 213.187C319.538 213.187 317.17 215.259 317.17 218.219V231.54H303.849C301.185 231.54 298.817 233.612 298.817 236.572C298.817 239.532 300.889 241.604 303.849 241.604H317.17V254.924C317.17 257.588 319.242 259.956 322.202 259.956C324.866 259.956 327.234 257.884 327.234 254.924V241.604H340.554C343.218 241.604 345.586 239.532 345.586 236.572C345.586 233.612 343.218 231.54 340.554 231.54Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_34_8869",
    x: 0.699516,
    y: 24.5053,
    width: 420.328,
    height: 319.3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 32.5606
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.5606
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_34_8869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_34_8869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_8869",
    x1: 210.769,
    y1: 52.6928,
    x2: 210.769,
    y2: 248.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpense2EmptyState);
export default __webpack_public_path__ + "static/media/expense2EmptyState.5c15e8a405f6f33c086db81cd354604d.svg";
export { ForwardRef as ReactComponent };